// apiservices.tsx
// This file containes the API services for the application.
//--------------------------------------------------------------------------
// Imports
//--------------------------------------------------------------------------

import { getJwtToken } from "./auth";
import config from "./config";

//--------------------------------------------------------------------------
// React Server
//--------------------------------------------------------------------------

const reactServer = config.reactServer;

//--------------------------------------------------------------------------
// GET
//--------------------------------------------------------------------------

//--------------------------------------------------------------------------
// Fetch profile
//--------------------------------------------------------------------------

export const fetchProfile = async (): Promise<any> => {
  const token = getJwtToken();

  if (!token) {
    console.warn("No token found, skipping profile fetch.");
    return null; 
  }

  try {
    const response = await fetch(`${reactServer}account/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Profile fetch failed: ${response.status}`);
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error; 
  }
};

//--------------------------------------------------------------------------
// Fetch all job types with id
//--------------------------------------------------------------------------

export const fetchJobTypes = async (): Promise<any[]> => {
  const token = getJwtToken();

  if (!token) {
    console.warn("No token found, skipping job_types fetch.");
    return null; 
  }
 
  try {
    const response = await fetch(`${config.reactServer}feedback/all-job-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Job types fetch failed: ${response.status}`);
    }

    const jobData = await response.json();

    if (!jobData.job_types) {
      throw new Error("No job_types found in response");
    }

    return jobData.job_types;
  } catch (error) {
    console.error("Error fetching job types:", error);
    throw error;
  }
};

//--------------------------------------------------------------------------
// Fetch all job summaries
//--------------------------------------------------------------------------

export const fetchJobSummaries = async (): Promise<any[]> => {
  const token = getJwtToken(); 

  if (!token) {
    console.warn("No token found, skipping job_summaries fetch.");
    return null; 
  }

  try {
    const response = await fetch(`${config.reactServer}feedback/all-job-summaries`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Summary types fetch failed: ${response.status}`);
    }

    const data = await response.json();

    if (!data.job_summaries) {
      throw new Error("No job_summaries found in response");
    }

    return data.job_summaries;
  } catch (error) {
    console.error("Error fetching job summaries:", error);
    throw error;
  }
};

//--------------------------------------------------------------------------
// POST
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
// Two Factor Authentication
//--------------------------------------------------------------------------
export const toggleTwoFactorAuth = async (
  profile: { email: string },
  isTwoFactorEnabled: boolean
): Promise<boolean> => {
  try {
    const token = getJwtToken(); 
    const newStatus = !isTwoFactorEnabled;

    const response = await fetch(`${reactServer}account/settings/2fa`, { 
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: profile.email,
        twofactorEnabled: newStatus,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return newStatus; 
  } catch (error) {
    console.error("Error updating 2FA status:", error);
    throw error; 
  }
};
